import React from 'react';
import styles from './Detail.module.scss';
import { TONE_COLOR, Tone } from '../detail';
import { series } from '../reportTheme';

interface InlineBarProps {
  /** 0-100, or undefined when not computable - drawn as an empty track and a dash. */
  value?: number;
  tone?: Tone;
  /** Hide the number beside the bar, e.g. when the column already prints it. */
  hideValue?: boolean;
}

/** A small horizontal bar with its percentage, for table cells and tiles. */
const InlineBar: React.FC<InlineBarProps> = ({ value, tone, hideValue }) => {
  const pct = typeof value === 'number' ? Math.max(0, Math.min(100, value)) : undefined;
  return (
    <span className={styles.barCell}>
      <span className={styles.bar}>
        {pct !== undefined && (
          <span
            className={styles.barFill}
            style={{ width: `${pct}%`, background: tone ? TONE_COLOR[tone] : series.blue }}
          />
        )}
      </span>
      {!hideValue && <span className={styles.barValue}>{pct !== undefined ? `${Math.round(pct)}%` : '—'}</span>}
    </span>
  );
};

export default InlineBar;
